import { useState } from "react"
import Modal from 'react-modal';
import useKeypress from "../ownHooks/pressEsc";

import { FehlerauswertungErrResp } from "../Fehler/FehlerauswertungErrResp";
import { MyModalButtons, MyModalCloseButton, MyModalContentDateInput, MyModalContentNumberInput, MyModalContentRow, MyModalContentSelectInput, MyModalContentSelectInputOption, MyModalContentTextInput, MyModalForm } from "../StyleSheets/ModalStyle";
import { MyCancelButton, MySaveButton } from "../StyleSheets/GeneralButtonStyles";
import { listDropdowns } from "../Tabellen/ConstTabKopf/BahnhofKopf";

var MonitorApi = require('monitor-api');

export default function BhfUpdate({ rowEntry, reloadData, instance, kategorien, typen, zweckverbaende }) {
    const [showModal, setShowModal] = useState(false);
    const [bahnhofUpdate, setBahnhofUpdate] = useState(new MonitorApi.UpdateBahnhof());
    const [upAvailable, setUpAvailable] = useState(false);
    const [dropdowns] = useState({
        "kategorien": kategorien,
        "typen": typen,
        "zweckverbaende": zweckverbaende
    });

    const formatDate = ddmmyyyy => {
        console.log("datum: ", ddmmyyyy)
        if (ddmmyyyy === null) {
            return null;
        }
        const arr = ddmmyyyy.split('.');
        var date = '';
        date = date.concat(arr[2], '-');
        if (arr[1].length < 2) {
            date = date.concat('0', arr[1], '-');
        } else {
            date = date.concat(arr[1], '-');
        }
        if (arr[0].length < 2) {
            date = date.concat('0', arr[0]);
        } else {
            date = date.concat(arr[0]);
        }
        return date
    }

    const [inputs, setInputs] = useState({});
    const [myComment, setMyComment] = useState('');
    const [classes, setClasses] = useState({});

    const resetClasses = () => {
        setClasses({
            bahnhof: "unchanged",
            kurz: "unchanged",
            xkoord: "unchanged",
            ykoord: "unchanged",
            kommentar: "unchanged",
            gueltig_von: "unchanged",
            gueltig_bis: "unchanged",
            id_kat: "unchanged",
            id_typ: "unchanged",
            id_zv: "unchanged"
        });
    }
    const openModal = event => {
        setMyComment(rowEntry.original.kommentar);
        setInputs({
            bahnhof: rowEntry.original.bahnhof,
            kurz: rowEntry.original.kurz,
            xkoord: rowEntry.original.xkoord,
            ykoord: rowEntry.original.ykoord,
            gueltig_von: formatDate(rowEntry.original.gueltig_von),
            gueltig_bis: formatDate(rowEntry.original.gueltig_bis),
            id_kat: rowEntry.original.idKat,
            id_typ: rowEntry.original.idTyp,
            id_zv: rowEntry.original.idZv
        });
        setBahnhofUpdate(pre => ({ ...pre, "bhfId": rowEntry.original.id }));
        resetClasses();
        setShowModal(true);
        setUpAvailable(false);
    }

    const closeModal = () => {
        setBahnhofUpdate({});
        setShowModal(false);
    }

    const changeInputs = event => {
        setBahnhofUpdate(old => ({ ...old, [event.target.name]: event.target.value }));
        if (event.target.name === 'kommentar') {
            setMyComment(event.target.value);
        }
        setClasses(pre => ({ ...pre, [event.target.name]: "changed" }));
        setUpAvailable(true);
    }

    const tinkerDropdowns = (acc) => {
        switch (acc) {
            case 'korr_kat':
                return (
                    <MyModalContentSelectInput name="id_kat" onChange={changeInputs} value={bahnhofUpdate.id_kat ? bahnhofUpdate.id_kat : inputs.id_kat} className={classes.id_kat}>
                        {dropdowns.kategorien.map(kat =>
                            <MyModalContentSelectInputOption value={kat.id} key={kat.id}
                                className={kat.id === inputs.id_kat ? "origin" : ""}>
                                {kat.kategorie}
                            </MyModalContentSelectInputOption>)}
                    </MyModalContentSelectInput>
                )
            case 'korr_typ':
                return (
                    <MyModalContentSelectInput name="id_typ" onChange={changeInputs} value={bahnhofUpdate.id_typ ? bahnhofUpdate.id_typ : inputs.id_typ} className={classes.id_typ}>
                        {dropdowns.typen.map(t =>
                            <MyModalContentSelectInputOption value={t.id} key={t.id}
                                className={t.id === inputs.id_typ ? "origin" : ""}>
                                {t.typ}
                            </MyModalContentSelectInputOption>)}
                    </MyModalContentSelectInput>
                )
            case 'korr_zv':
                return (
                    <MyModalContentSelectInput name="id_zv" onChange={changeInputs} value={bahnhofUpdate.id_zv ? bahnhofUpdate.id_zv : inputs.id_zv} className={classes.id_zv}>
                        {dropdowns.zweckverbaende.map(z =>
                            <MyModalContentSelectInputOption value={z.id} key={z.id}
                                className={z.id === inputs.id_zv ? "origin" : ""}>
                                {z.name}
                            </MyModalContentSelectInputOption>)}
                    </MyModalContentSelectInput>
                )
            default:
                console.log('Unknown column');
                break;
        }
    }

    const saveChanges = event => {
        event.preventDefault();

        console.log('speichern korrektur:');

        let result = new Promise((resolve) =>
            instance.updateBahnhofBahnhofBahnhofIdPatch(bahnhofUpdate, (error, data, response) => {
                if (error) {
                    FehlerauswertungErrResp(error, response);
                    resolve(error);
                } else {
                    alert(`Änderungen gespeichert`);
                    resolve(data);
                }
            }))
        result.then((msg) => {
            closeModal();
            reloadData();
        })
    }

    const saveAndCreate = event => {
        event.preventDefault();
        console.log("speichern neu:");

        if (!bahnhofUpdate.gueltig_von) {
            alert("Neuer Gültigkeitsbeginn muss eingetragen werden.");
        } else {
            let result = new Promise((resolve) =>
                instance.updateAndCreateBahnhof(bahnhofUpdate, (error, data, response) => {
                    if (error) {
                        FehlerauswertungErrResp(error, response);
                        resolve(error);
                    } else {
                        alert(`Änderungen gespeichert`);
                        resolve(data);
                    }
                }))
            result.then((msg) => {
                closeModal();
                reloadData();
            })
        }
    }

    useKeypress('Escape', () => {
        closeModal();
    });

    return (
        <>
        {!rowEntry.original.gesperrt ? <>
            <button onClick={openModal} className="update-bttn">Bearbeiten</button>
            <Modal isOpen={showModal} className="modal">
                <MyModalCloseButton onClick={closeModal}>&#10007; </MyModalCloseButton>
                <MyModalForm >
                    <h3>Änderungen eintragen:</h3>
                    <MyModalContentRow>
                        <label>Bezeichnung:
                            <MyModalContentTextInput name="bahnhof" onChange={changeInputs}
                                value={bahnhofUpdate.bahnhof ? bahnhofUpdate.bahnhof : inputs.bahnhof}
                                className={classes.bahnhof} />
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow>
                        <label>Abkürzung:
                            <MyModalContentTextInput name="kurz" onChange={changeInputs}
                                value={bahnhofUpdate.kurz ? bahnhofUpdate.kurz : inputs.kurz}
                                className={classes.kurz} />
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow>
                        <label>x-Koordinate:
                            <MyModalContentNumberInput min="11.5" max="15.1" step="0.00001" name="xkoord"
                                value={bahnhofUpdate.xkoord ? bahnhofUpdate.xkoord : inputs.xkoord}
                                onChange={changeInputs}
                                className={classes.xkoord} />
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow>
                        <label>y-Koordinate
                            <MyModalContentNumberInput min="50.1" max="52" step="0.00001" name="ykoord"
                                value={bahnhofUpdate.ykoord ? bahnhofUpdate.ykoord : inputs.ykoord}
                                onChange={changeInputs} className={classes.ykoord} />
                        </label>
                    </MyModalContentRow>
                    {listDropdowns.map(it =>
                        <MyModalContentRow>
                            <label>{it.Header}:
                                {tinkerDropdowns(it.accessor)}
                            </label>
                        </MyModalContentRow>
                    )}
                    <MyModalContentRow>
                        <label>Gültigkeitsbeginn ({inputs.gueltig_von}):
                            <MyModalContentDateInput name="gueltig_von"
                                value={bahnhofUpdate.gueltig_von ? bahnhofUpdate.gueltig_von : inputs.gueltig_von}
                                onChange={changeInputs}
                                className={classes.gueltig_von} />
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow>
                        <label>Gültigkeitsende {inputs.gueltig_bis ? `(${inputs.gueltig_bis})` : ""}:
                            <MyModalContentDateInput name="gueltig_bis"
                                value={bahnhofUpdate.gueltig_bis ? bahnhofUpdate.gueltig_bis : inputs.gueltig_bis}
                                onChange={changeInputs}
                                className={classes.gueltig_bis} />
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow>
                        <label>Kommentar:
                            <MyModalContentTextInput name="kommentar"
                                value={myComment}
                                onChange={changeInputs}
                                className={classes.kommentar} />
                        </label>
                    </MyModalContentRow>
                    <br></br>
                    <aside>* Gültigkeitsbeginn notwendig bei (Neu).</aside>
                    <aside>** Speichern (Korrektur) nur wählen, wenn bestehende Daten überschrieben werden sollen! **</aside>
                    <MyModalButtons>
                        <MySaveButton type="submit" disabled={!upAvailable} onClick={saveChanges}>Speichern (Korrektur)</MySaveButton>
                        <MySaveButton type="submit" disabled={!upAvailable} onClick={saveAndCreate}>Speichern (Neu anlegen)</MySaveButton>
                        <MyCancelButton onClick={closeModal}>Abbruch</MyCancelButton>
                    </MyModalButtons>
                </MyModalForm>
            </Modal>
        </> :
        <>
        <label style={{display: 'flex', justifyContent: 'center'}}>- gesperrt -</label>
        </>}
        </>
    )
}